import ReactDOM, { type Root } from "react-dom/client"
import { HttpError } from "@/shared/api/errors"
import { captureError } from "@/shared/lib/diagnostics"

const onReactError = (error: unknown) =>
	captureError(error, {
		scope: "react.boundary",
		...(error instanceof HttpError && {
			http_status: error.status,
			http_path: error.path,
			http_method: error.method,
		}),
	})

export function createReactRoot(): Root {
	const rootEl = document.getElementById("root")
	if (!rootEl) {
		throw new Error("Root element #root not found")
	}

	return ReactDOM.createRoot(rootEl, {
		onUncaughtError: onReactError,
		onCaughtError: onReactError,
		onRecoverableError: onReactError,
	})
}
